import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { useFindProfile } from '@hooks/profile'
import { api } from '@services/apiClient'

interface IAreas {
  code: string
  description: string
  id: number
  isActive: boolean
}

export const useFindSiteAreas = () => {
  const { data: user } = useFindProfile()
  const { isMockEnvironment } = useMockEnvironment()

  const siteId = user && user.selectedSite.id

  const fetchSiteAreas = async () => {
    if (!isMockEnvironment) {
      const url = `sites/${siteId}/areas`
      const { data } = await api.get<IAreas[]>(url)
      return data
    }

    return []
  }

  return useQuery({ queryKey: ['AREAS'], queryFn: fetchSiteAreas })
}
